import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAboutUs } from '../../../redux/slices/aboutUsSlice';
import { Box, Typography, Grid, Tabs, Tab } from '@mui/material';
import { IoMdCall } from 'react-icons/io';
import './AboutSection.scss';
import imgMain from './../../../assets/images/about/main-image.png';
import imgSmall from './../../../assets/images/about/small-image.png';
import triangular from './../../../assets/images/about/triangular.png';
import CustomButton from '../../CustomButton/CustomButton';
import { IoMdShareAlt } from "react-icons/io";
import BubblesBackground from "./../../../common/BubblesBackground";
import CornerImage from './../../CornerImage/CornerImage';
import { useNavigate } from "react-router-dom";
import { BiSolidShare } from "react-icons/bi";
import Loading from '../../UI/Loading/Loading';
const AboutSection = ({ t, direction, language }) => {
    const dispatch = useDispatch();
    const { data, status, error } = useSelector((state) => state.aboutUs);
    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchAboutUs({ language }));
        }
    }, [dispatch, status]);
    // Start from the second tab (index 1)
    const [value, setValue] = useState(0);  // Set initial value for second item in filtered list

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };
    // Filter data to exclude the first item (id: 1)
    const filteredData = data?.message?.filter(tab => tab.id !== 1) || [];

    const navigate = useNavigate();
    const handleButtonClick = () => {
        window.scrollTo(0, 0);
        navigate("/about");
    };
    // Check if the current URL is "/about"
    const isAboutPage = window.location.pathname === '/about';
    return (
        <Box data-aos="fade-up" sx={{ direction: direction === 'rtl' ? 'rtl ' : 'ltr' }}>
            {status === 'loading' ? (
                <Loading />
                //   ) : status === 'failed' ? (
                //     <Typography>Error: {error}</Typography>
            ) : (
                data && (

                    <Box className="about-section" sx={{
                        pt: '20px',
                        // pl: { xs: '50px', lg: '100px', xl: '160px' },
                        pr: { xs: '50px', lg: '100px', xl: '160px' },

                    }}>
                        {/* <BubblesBackground top="-33px" right="auto" left={0} bottom="auto" /> */}

                        <Grid container spacing={2} alignItems="center" sx={{ margin: "0px" }}>
                            {/* Left Section - Images */}
                            <Grid
                                item
                                xs={12}
                                md={6}
                                sx={{
                                    position: "relative",
                                    display: "flex",
                                    justifyContent: { xs: "center", md: "center" },
                                    paddingLeft: "0px !important",
                                    direction: direction === 'rtl' ? 'ltr ' : 'ltr',

                                }}
                            >
                                <Box className="image-container" >
                                    <img src={imgMain} alt="Main" className="main-image"  loading="lazy"/>
                                    <img src={imgSmall} alt="Small" className="small-image"  loading="lazy"/>
                                    {/* <img src={triangular} alt="Triangle" className="corner-image" /> */}
                                    <CornerImage position={{ bottom: '3px', left: '6%' }} width="20%" />

                                </Box>
                            </Grid>


                            {/* Right Section - Content */}
                            <Grid item xs={12} md={6} sx={{ textAlign: direction === 'rtl' ? 'right ' : 'left', paddingLeft: "0px !important", direction: direction === 'rtl' ? 'rtl ' : 'ltr' }}>
                                <Box data-aos="fade-down" >
                                    <Typography variant="h6" className="section-tag" >
                                        {t.sectionTag}
                                    </Typography>
                                </Box>

                                <Typography className="section-title" gutterBottom>
                                    {data.message[0]?.name} {/* This will show "من هي عوين" */}
                                </Typography>

                                <Typography variant="body1" className="section-paragraph" gutterBottom>
                                    {language === 'Arabic' ? data.message[0]?.aboutUsDescription[0]?.valueAr : data.message[0]?.aboutUsDescription[0]?.valueEn}
                                </Typography>

                                {/* Tabs for "رسالتنا", "قيمنا", "رؤيتنا" */}
                                <Box sx={{ borderBottom: 1, borderColor: 'divider', color: "#000", direction }}>
                                    <Tabs value={value} onChange={handleTabChange} aria-label="About Us Tabs"
                                        variant="scrollable"
                                        // scrollButtons
                                        allowScrollButtonsMobile
                                    >
                                        {filteredData.map((tab, index) => (
                                            <Tab
                                                key={tab.id}
                                                label={language === 'Arabic' ? tab.name : tab.name} // Display tab name based on language
                                                sx={{ fontSize: "16px", fontWeight: 700 }}
                                            />
                                        ))}
                                    </Tabs>
                                </Box>


                                {/* Tab content */}
                                <Box sx={{
                                    marginTop: '20px', display: 'flex', flexDirection: 'column', maxHeight: {
                                        xs: '200px', // Increased height for small screens
                                        sm: '180px', // Slightly reduced for small to medium screens
                                        md: '140px', // Default height for medium and larger screens
                                    },
                                    overflowY: filteredData[value]?.aboutUsDescription.length > 3 ? 'auto' : 'visible', // Enable scrolling if more than three items

                                }}>
                                    {/* Loop through features and display based on tab value */}
                                    {filteredData[value]?.aboutUsDescription.map((desc) => (// Group features by tab, assuming 2 features per tab
                                        <Box key={desc.id} sx={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    color: 'var(--custom-gold)',
                                                    marginLeft: direction === "rtl" ? '10px' : "0px",
                                                    marginRight: direction === "rtl" ? '0px' : "10px",
                                                    flexShrink: 0, // Prevent icon from shrinking
                                                }}
                                            >
                                                {direction === "ltr" ? (
                                                    <BiSolidShare style={{ fontSize: '20px' }} />
                                                ) : (
                                                    <IoMdShareAlt style={{ fontSize: '20px' }} />
                                                )}

                                            </Box>
                                            <Typography className="feature-text">
                                                {language === 'Arabic' ? desc.valueAr : desc.valueEn}
                                            </Typography>
                                        </Box>

                                    ))}
                                </Box>
                                {!isAboutPage && (
                                    <>
                                        {/* Button with 'ltr' direction */}
                                        <Box sx={{ textAlign: 'left', width: '100%' }}>
                                            <CustomButton
                                                text={t.more}
                                                // icon={IoMdCall}
                                                onClick={handleButtonClick}
                                                sx={{ direction: 'ltr' }}
                                            />
                                        </Box>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                )
            )}
        </Box>
    );
};


export default AboutSection;
